<style scoped lang="scss">
    .modal-box {
        background-color: #fff;
    }
    form {
        h2 {
            color: #000;
        }
        ::v-deep(.formkit-label), ::v-deep(legend) {
            color: #000 !important;
            font-weight: 400;
        }
    }
</style>
<template>
    <dialog ref="HTMLDialogElement" :id="duplicateProductModalId" class="modal modal-middle sm:modal-middle">
        <div class="modal-box" method="dialog">
            <FormKit
                type="form"
                id="duplicateProductForm"
                @submit="submitHandler"
                :actions="false"
            >
                <h2>Souhaitez-vous dupliquer ce produit ?</h2>
                <h3>S’il en a, ses variants seront aussi dupliqués.</h3>
                <FormKit
                    type="select"
                    label="Prototype associé au produit :"
                    name="prototype"
                    :options="[
                      { label: 'E-billet', value: PRODUCT_PROTOTYPES.TICKET},
                      { label: 'Physique', value: PRODUCT_PROTOTYPES.PHYSICAL },
                    ]"
                />
                <h3 class="text-red-600">Par défaut, si aucun moyen d'expédition physique n'est <br>
                disponible pour le fournisseur, un e-billet sera automati-<br>
                quement sélectionné. Vous devrez ensuite le modifier manuellement après la duplication.</h3>
                <div class="modal-action">
                    <button type="button" class="btn" @click="closeModalDialog()">Annuler</button>
                    <FormKit type="submit" label="Dupliquer" />
                </div>
            </FormKit>
        </div>
    </dialog>
</template>

<script lang="ts" setup>
import { ref, onMounted, toRef } from "vue";
import {PRODUCT_PROTOTYPES} from "@/constants/product/properties";
import {productService} from "@/_services/product/product";
import {IDupliacteMasterProduct} from "@/models/product/IMasterProduct";
import Swal from "@/_helpers/swal";

const props = defineProps({
    productUuid: {
        type: String,
        required: true,
        default: "",
    },
    duplicateProductModalId: {
        type: String,
        required: true,
    },
});
const duplicateProductModalId = toRef(props, "duplicateProductModalId");
const modalHTMLElement = ref<HTMLDialogElement | null>(null);
const productUuid = toRef(props, "productUuid");

onMounted(() => {
    modalHTMLElement.value = document.querySelector(
        `#${duplicateProductModalId.value}`
    );
});

const closeModalDialog = () => {
    if (modalHTMLElement.value) {
        modalHTMLElement.value.close();
    }
};

const submitHandler = async (data) => {
    try {
        const params: IDupliacteMasterProduct = {
            uuid: productUuid.value,
            prototypeUuid: data.prototype
        }
        const res = await productService.duplicateMasterProduct(params);
        closeModalDialog();
        if (res) {
            Swal.info("Le produit a bien été dupliqué.");
        } else {
            Swal.error("Erreur lors de la duplication du produit");
        }

    } catch (err: any) {
        Swal.error("Erreur coté API");
    }
}
</script>